import { render, staticRenderFns } from "./AsignacionSitrackPantalla.vue?vue&type=template&id=69564e02&"
import script from "./AsignacionSitrackPantalla.vue?vue&type=script&lang=ts&"
export * from "./AsignacionSitrackPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('69564e02', component.options)
    } else {
      api.reload('69564e02', component.options)
    }
    module.hot.accept("./AsignacionSitrackPantalla.vue?vue&type=template&id=69564e02&", function () {
      api.rerender('69564e02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Asignacion_sitrack/AsignacionSitrackPantalla.vue"
export default component.exports